import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { IVerifyPinReqBody, IVerifyPinEntity } from '../../../entity';

export interface IVerifyPinUseCase {
    execute(reqBody: IVerifyPinReqBody): Promise<IVerifyPinEntity>;
}

export class VerifyPinUseCase implements IVerifyPinUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(reqBody: IVerifyPinReqBody): Promise<IVerifyPinEntity> {
        return await this.userRepo.verifyPin(reqBody);
    }
}
